import { createContext, useContext, useEffect, useReducer } from "react";
import {
  testReducer,
  INITIAL_STATE,
  types,
} from "../../reducers/inventory/testReducer";
import axiosClient from "../../api/axios";
import {
  alertSuccess,
  showTypeErrorFetch,
} from "../../utilities/alerts.utilities";
import { LOADING, STATUS_NOT_LOADED } from "../../api/constant";
import { useParams } from "react-router-dom";
const TestFormContext = createContext({});
const TestFormProvider = ({ children }) => {
  const { test_id, parent_id } = useParams();
  const [state, dispatch] = useReducer(testReducer, INITIAL_STATE);
  const { lookForCode } = state;
  useEffect(() => {
    if (state.test.id) {
      async function fetchData() {
        const {
          type,
          name,
          description,
          version,
          created_at,
          is_active,
          reference,
          parent_id,
        } = await getTestById(state.test.id);
        dispatch({
          type: types.CHANGE_PAYLOAD_TEST,
          payload: {
            ...state.test,
            type,
            name,
            description,
            created_at,
            version,
            is_active,
            reference,
            parent_id,
            to_edit: false,
          },
        });
        dispatch({
          type: types.RELOAD_OBSERTATIONS,
        });
        dispatch({
          type: types.RELOAD_DOCUMENTS,
        });
      }

      fetchData();
    }
  }, [state.test.id]);
  useEffect(() => {
    if (test_id) {
      dispatch({
        type: types.SET_TEST_ID,
        payload: test_id,
      });
    }
  }, [test_id]);

  useEffect(() => {
    if (parent_id) {
      dispatch({
        type: types.CHANGE_OBJECT_TEST,
        payload: {
          ...state.test,
          parent_id,
        },
      });
    }
  }, [parent_id]);
  useEffect(() => {
    if (state.test.test_version.version_id) {
      axiosClient()
        .get(
          `inventory/test/${state.test.test_version.version_id}/getObservations`
        )
        .then(({ data }) => {
          dispatch({
            type: types.OBSERVATIONS_LOADED,
            payload: data,
          });
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
  }, [state.test.observation.status, state.test.test_version.version_id]);
  useEffect(() => {
    if (state.test.test_version.version_id) {
      axiosClient()
        .get(`inventory/test/${state.test.test_version.version_id}/documents`)
        .then(({ data }) => {
          dispatch({
            type: types.DOCUMENTS_LOADED,
            payload: data,
          });
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
  }, [state.test.document.status, state.test.test_version.version_id]);
  useEffect(() => {
    if (state.test.id && state.test.version_list.status === STATUS_NOT_LOADED) {
      axiosClient()
        .get(`inventory/test/${state.test.id}/getVersions`)
        .then(({ data }) => {
          dispatch({
            type: types.VERSIONS_LOADED,
            payload: data,
          });
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
  }, [state.test.version_list.status, state.test.id]);
  useEffect(() => {
    if (state.test.test_version.version_id) {
      axiosClient()
        .get(
          `inventory/test/${state.test.test_version.version_id}/getItemsTest`
        )
        .then(({ data }) => {
          dispatch({
            type: types.ITEMS_TEST_LOADED,
            payload: data,
          });
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
  }, [state.test.items_test.status, state.test.test_version.version_id]);
  useEffect(() => {
    if (lookForCode.length > 4) {
      lookForItemByCode(lookForCode);
    } else {
      dispatch({ type: types.ITEMS_FOUND, payload: [] });
    }
  }, [lookForCode]);
  const createTest = () => {
    axiosClient()
      .post(`inventory/createTest`, {
        type: state.test.type,
        name: state.test.name,
        description: state.test.description,
        version: state.test.version,
        id: state.test.id,
        is_active: state.test.is_active,
        reference: state.test.reference,
        parent_id: state.test.parent_id,
      })
      .then(({ data }) => {
        dispatch({
          type: types.CHANGE_OBJECT_TEST,
          payload: {
            ...state.test,
            id: data.id,
            created_at: data.created_at,
            to_edit: false,
          },
        });
        alertSuccess("Cambios realizados satisfactoriamente");
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  };
  const createVersion = () => {
    axiosClient()
      .post(`inventory/createVersion`, {
        description: state.test.test_version.description,
        version: state.test.test_version.version,
        parent_id: state.test.id,
      })
      .then(({ data }) => {
        alertSuccess("Versión creada satisfactoriamente");
        dispatch({
          type: types.CLEAN_FORM_NEW_VERSION_AND_RELOAD
        });
        
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  };
  const addObservation = () => {
    if (state.test.id) {
      axiosClient()
        .post(
          `inventory/test/${state.test.test_version.version_id}/notificated`,
          {
            note: state.test.observation.text,
          }
        )
        .then(({ data }) => {
          dispatch({
            type: types.CHANGE_INPUT_OBSERVATION,
            payload: { name: "text", value: "" },
          });
          dispatch({ type: types.RELOAD_OBSERTATIONS });
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
  };
  const getTestById = (test_id_to_find) => {
    return axiosClient()
      .get(`inventory/getTestById/${test_id_to_find}`)
      .then(({ data }) => {
        return data;
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  };
  const lookForItemByCode = (code) => {
    dispatch({ type: types.CHANGE_STATUS_LOOK_FOR_CODE, payload: LOADING });
    axiosClient()
      .post(`inventory/getItemByLikeCode`,{code_name:code})
      .then(({ data }) => {
        dispatch({ type: types.ITEMS_FOUND, payload: data });
      })
      .catch((e) => {
        dispatch({
          type: types.CHANGE_STATUS_LOOK_FOR_CODE,
          payload: STATUS_NOT_LOADED,
        });
        showTypeErrorFetch(e);
      });
  };
  const addItemTest = () => {
    axiosClient()
      .post(`inventory/saveItemsTest/${state.test.test_version.version_id}`, {
        quantity: state.test.item_quantity,
        inventory_item_id: state.test.item_id,
      })
      .then(({ data }) => {
        dispatch({
          type: types.RELOAD_ITEMS_TEST,
        });
        dispatch({ type: types.REMOVE_ITEM })
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  };
  const deleteItemVersion = (item_test_id) => {
    axiosClient()
      .delete(`inventory/deleteItemTest/${item_test_id}`)
      .then(({ data }) => {
        dispatch({
          type: types.RELOAD_ITEMS_TEST,
        });
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  };
  
  const addDocumentsToTest = async (pictures) => {
    for await (const document of pictures) {
      var formData = new FormData();
      formData.append("document", document);
      await axiosClient()
        .post(
          `inventory/test/${state.test.test_version.version_id}/documented`,
          formData
        )
        .then(({ data }) => {
          return data;
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
    dispatch({ type: types.RELOAD_DOCUMENTS });
  };
  const updateFieldVersion = (version_id, form) => {
    axiosClient()
      .post(`inventory/test/${version_id}`, form)
      .then(({ data }) => {
        dispatch({
          type: types.RELOAD_VERSIONS,
        });
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  };
  return (
    <TestFormContext.Provider
      value={[
        state,
        dispatch,
        {
          createTest,
          addObservation,
          addItemTest,
          createVersion,
          addDocumentsToTest,
          updateFieldVersion,
          deleteItemVersion
        },
      ]}
    >
      {children}
    </TestFormContext.Provider>
  );
};
const useTest = () => useContext(TestFormContext)[0];
const useDispatchTestForm = () => useContext(TestFormContext)[1];
const useActionsTest = () => useContext(TestFormContext)[2];

export { TestFormContext, useTest, useDispatchTestForm, useActionsTest };
export default TestFormProvider;
